import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
/*import scheduleIcon from "../../../assets/landing-how-schedule.png";
import pickupIcon from "../../../assets/landing-how-pickup.png";
import analysisIcon from "../../../assets/landing-how-analysis.png";
import resultsIcon from "../../../assets/landing-how-results.png";
*/
import step1 from "../../../assets/step1.png";
import step2 from "../../../assets/step2.png";
import step3 from "../../../assets/step3.png";
import step4 from "../../../assets/step4.png";
import imgStep1 from "../../../assets/step1-test-packaging.png";
import imgStep2 from "../../../assets/step2-results-and-recommendations.png";
import imgStep3 from "../../../assets/step3-nutritionists.png";
import imgStep4 from "../../../assets/step4-healthy-food-delivery.png";
import { useHistory } from "react-router-dom";

function LandingHowItWorks() {
  
  const history = useHistory();

  return (
    
    <div>
          
        <div className="landing-how" id="como-funciona">
          <div id="landing-rogue-circle" />
          <div className="landing-how-texts">
            <Typography variant="h1" component="h2" className="landing-title">
              Así funciona
            </Typography>
            <p className="landing-p">
              Las pruebas de Mr.Gen son muy sencillas de realizarse, solo necesitas
              una muestra de saliva.
            </p>
          </div>
          <div className="landing-how-steps">
            <div className="landing-how-steps-container">
              <div className="landing-how-steps-img">
                <img src={step1} alt="Realizar test" />
              </div>
              <div className="landing-how-steps-no">
                <p>1</p>
              </div>

              <p className="landing-how-steps-text">Realizá tu test</p>
          </div>
          <div className="landing-how-steps-container">
            <div className="landing-how-steps-img">
              <img src={step2} alt="Recibí resultados y recomendaciones" />
            </div>
            <div className="landing-how-steps-no">
              <p>2</p>
            </div>
            <p className="landing-how-steps-text">Recibí resultados y recomendaciones</p>
          </div>
          <div className="landing-how-steps-container">
            <div className="landing-how-steps-img">
              <img src={step3} alt="Agendá consultas nutricionales" />
            </div>
            <div className="landing-how-steps-no">
              <p>3</p>
            </div>
            <p className="landing-how-steps-text">Agendá tu consulta nutricional</p>
          </div>
          <div className="landing-how-steps-container">
            <div className="landing-how-steps-img">
              <img src={step4} alt="Contratá tu menú diario personalizado" />
            </div>
            <div className="landing-how-steps-no">
              <p>4</p>
            </div>
            <p className="landing-how-steps-text">
              Contratá tu menú diario personalizado
            </p>
          </div>
        </div>
        <div className="steps-explained">
          <div className="step-one steps-items">
            <div className="stepTitle"><h1>1</h1><h2> Realizá tu test</h2></div>
            <p className="stepText">Analizamos 31 polimorfismos asociados a tus genes. Con esta información podemos conocer cómo tu cuerpo asimila los nutrientes. 
              <br/><br/><strong>Este test no es invasivo, es rápido e indoloro.</strong></p>
            <img className="stepImg" src={imgStep1} alt="Kit Mr. GEN" />
          </div>
          <div className="step-two steps-items">
            <div className="stepTitle"><h1>2</h1><h2> Recibí tus recomendaciones alimenticias</h2></div>
            <p className="stepText">A partir del análisis genético generamos recomendaciones alimenticias de acuerdo a tu perfil genético.
              <br/><br/><strong>Sugerimos cerca de 300 alimentos en función de tu diagnóstico.</strong></p>
            <img className="stepImg" src={imgStep2} alt="Resultados y recomendaciones alimenticias" />
          </div>
          <div className="step-three steps-items">
            <div className="stepTitle"><h1>3</h1><h2> Agendá tu consulta nutricional</h2></div>
            <p className="stepText">Nuestro equipo está integrado por nutricionistas con amplia experiencia, capacitados en Nutrigenética y especializados en la elaboración de planes alimenticios basados en tu perfil genético. 
              <br/></p>
            <img className="stepImg" src={imgStep3} alt="Agendá consultas con nutricionistas" />
          </div>
          <div className="step-four steps-items">
            <div className="stepTitle"><h1>4</h1><h2> Contratá un menú diario saludable y personalizado</h2></div>
            <p className="stepText">Trabajamos con restaurantes y casas de comida de primer nivel. Los menú son diseñados por nuestro equipo de nutricionistas y chefs. 
            <br/><br/><strong>Cada plato es preparado en el día y enviado a tu casa u oficina.</strong></p>
            <img className="stepImg" src={imgStep4} alt="Contratá tu menú diario saludable y personalizada" />
          </div>
        </div>
      </div>
      <div className="landing-intro-prep-meals">
        <div className="prep-meals-text">
          <h1>
          Disfrutá tu alimentación
          </h1>
          <h2>
          Recibí platos saludables cada día
          </h2>
          <p>
          Elegí entre más de 15 opciones diferentes cada semana. <br/>
          Cada plato está elaborado de manera artesanal, <br />cuidando la calidad de los ingredientes.
          </p>
          <div className="cover-texts-button">
            <Button
              color="primary"
              variant="contained"
              disableElevation
              onClick={() => history.push('/platos-semanales')}
              >
              Probar ahora
            </Button>
          </div>
        </div>
        <div className="prep-meals-img">
         <div className="rel-div">
          <div className="abs-div">
          <img 
            src="https://res.cloudinary.com/hqs-cdn/image/upload/v1694195913/landing-prep-meal-example_qz2pa6.svg" 
          />
          </div>
         </div>
        </div>
      </div>
      <div className="landing-intro-banner" />
    </div>
  );
}

export default LandingHowItWorks;
